import { render, staticRenderFns } from "./mobileHome.vue?vue&type=template&id=53686448&scoped=true&"
import script from "./mobileHome.vue?vue&type=script&lang=js&"
export * from "./mobileHome.vue?vue&type=script&lang=js&"
import style0 from "./mobileHome.vue?vue&type=style&index=0&id=53686448&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53686448",
  null
  
)

export default component.exports